
































































































































































































































































































































































































































































































































import { Vue, Component, Watch, Ref, Prop } from 'vue-property-decorator'
import { CancelarVendaUseCase, EditarUmaVendaUseCase, FindLojaUseCase } from '@/usecases'
import { FiltroDeVenda, NotaDaVenda, PontoDeVenda, ResumoDaVenda } from '@/models'
import { VendaModule } from '@/store/vuex/venda/VendaStore'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import {
	formatarMoeda,
	removerFormatacaoDeCnpjOuCpf,
} from '@/shareds/formatadores'
import GridDeVenda from '@/views/application/venda/GridDeVenda.vue'
import { DataOptions } from 'vuetify'
import { dateTimeToPtBrFormat } from '@/shareds/date/date-utils'
import Confirmacao from '@/components/ui/Confirmacao.vue'
import DialogoDeDetalhesDaVenda from '@/components/venda/DialogoDeDetalhesDaVenda.vue'
import {
	obterDisplayClienteDaVenda,
	obterTotalDaVenda,
} from '@/shareds/venda-shareds'
import mapErrosSefaz from '@/shareds/fiscal/tabelas/mapErrosSefaz'
import moment from 'moment'
import { FindVendaUseCase } from '@/usecases'
import SelecaoDePdv from '@/components/venda/SelecaoDePdv.vue'
import SeletorDeLojasDoUsuario from '@/components/loja/SeletorDeLojasDoUsuario.vue'
import CamposDeFiltrosDeVendas from '@/views/application/venda/CamposDeFiltrosDeVendas.vue'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import { nextTick } from '@/shareds/utils'
import { sortConverter } from '@/shareds/paginacao'
import { CancelarNotaFiscalUseCase } from '@/usecases/fiscal/CancelarNotaFiscalUseCase'
import RodapePersonalizado from '@/components/ui/data-tables/RodapePersonalizado.vue'
import DialogoDeInformarEmail from './DialogoDeInformarEmail.vue'
import DialogoDeCancelarPagamentos from '@/components/venda/DialogoDeCancelarPagamentos.vue'
import RestPdvService from '@/services/pdv/RestPdvService'
import DialogoDeAutenticacao from './DialogoDeAutenticacao.vue'
import DialogoDeConfirmacaoDeCancelamentoDeVenda from './DialogoDeConfirmacaoDeCancelamentoDeVenda.vue'

const FILTRO_DE_VENDAS = 'FILTRO_DE_VENDAS'

@Component({
	components: {
		Confirmacao,
		GridDeVenda,
		DialogoDeDetalhesDaVenda,
		CamposDeFiltrosDeVendas,
		SeletorDeLojasDoUsuario,
		SelecaoDePdv,
		RodapePersonalizado,
		DialogoDeInformarEmail,
		DialogoDeCancelarPagamentos,
		DialogoDeAutenticacao,
		DialogoDeConfirmacaoDeCancelamentoDeVenda,
	},
})
export default class TelaDeVendas extends Vue {
	@Ref() dialogoDeFiltros!: CamposDeFiltrosDeVendas
	@Ref() form!: HTMLFormElement
	@Ref() dialogoDeInformarEmail!: DialogoDeInformarEmail
	@Ref() dialogoDeAutenticacao!: DialogoDeAutenticacao
	@Ref() confirmacao!: Confirmacao
	@Ref() dialogoDeConfirmacaoDeCancelamentoDeVenda!: DialogoDeConfirmacaoDeCancelamentoDeVenda
	@Prop({ type: Array, default: undefined }) lojas?: string[]
	buscando = false
	vendas: ResumoDaVenda[] = []
	findUseCase = new FindVendaUseCase()
	editarUmaVendaUseCase = new EditarUmaVendaUseCase()

	findLojaUseCase = new FindLojaUseCase()
	cancelarVendaUseCase = new CancelarVendaUseCase()
	cancelarNotaFiscalUseCase = new CancelarNotaFiscalUseCase()
	pdvs: PontoDeVenda[] = []
	mostra = false
	buscandoPdvs = false
	permissaoConcedida: boolean | undefined = false
	vendaSelecionada = null

	pdvService = new RestPdvService()
	filtro: FiltroDeVenda = localStorage[FILTRO_DE_VENDAS]
		? JSON.parse(localStorage[FILTRO_DE_VENDAS])
		: {
			busca: '',
			loja: '',
			datas: [],
			horas: [null, null],
			cliente: '',
			exibeVendasComErros: false,
			ambientes: ['Produção', 'Homologação'],
			vendasComOrcamento: false,
		}
	totalRegistros = -1
	dateTimeToPtBrFormat = dateTimeToPtBrFormat
	podeVisualizar: boolean | null = null

	cancelando: string[] = []
	cancelandoNotasFiscais: string[] = []
	enviandoEmail: string[] = []

	paginacao: DataOptions = {
		page: 0,
		itemsPerPage: 10,
		sortBy: [],
		sortDesc: [],
		groupBy: [],
		groupDesc: [],
		multiSort: false,
		mustSort: false,
	}

	get podeCancelarVenda() {
		return UserLoginStore.permiteRegraDeNegocio('pode-cancelar-venda')
	}

	get acessoIrrestrito() {
		return UserLoginStore.permiteRegraDeNegocio('acesso-irrestrito')
	}

	get podeCancelarDevolucao() {
		return UserLoginStore.permiteRegraDeNegocio('pode-cancelar-devolucoes')
	}

	get autenticacaoObrigatoriaParaVenda(){
		return UserLoginStore.permiteRegraDeNegocio('autenticacao-obrigatoria-para-cancelar-vendas')
	}

	get podeCancelarNota() {
		return UserLoginStore.permiteRegraDeNegocio('pode-cancelar-nota-fiscal')
	}

	get podeEnviarPorEmail() {
		return UserLoginStore.permiteRegraDeNegocio('pode-enviar-notas-por-email')
	}

	get autenticacaoObrigatoriaParaDevolucao(){
		return UserLoginStore.permiteRegraDeNegocio('autenticacao-obrigatoria-para-cancelar-devolucoes')
	}

	validarSePodeCancelarVenda(venda: ResumoDaVenda) {
		if (venda.notas.filter(nota => nota.cstat === '0').length > 0) return false
		if (
			!venda.temDevolucao &&
			venda.situacao !== 'Cancelada' &&
			venda.notas &&
			!venda.possuiPagamentoTefCreditado
		)
			return true

		return false
	}

	get exibirSomenteVendasDoPdvAtivo() {
		return UserLoginStore.permiteRegraDeNegocio('exibir-somente-vendas-do-pdv-ativo')
	}

	get pdvLogado() {
		return this.turnoDeVenda?.pontoDeVenda.ativo
	}

	displayNfSerie (venda: ResumoDaVenda ){
		const nota = venda.notas[0]
		return nota
			? nota.nnf + ' / ' + nota.serie
			: ''
	}

	displayTotalDaVenda(venda: ResumoDaVenda) {
		return formatarMoeda(venda.total)
	}

	displayStatusDaNota(venda: ResumoDaVenda) {
		const nota = venda.notas[0]
		return nota && mapErrosSefaz[nota.cstat]
			? nota.cstat + ' - ' + mapErrosSefaz[nota.cstat]
			: nota?.cstat || ''
	}

	displayNotasFiscais(venda: ResumoDaVenda): string {
		return venda.notas
			.filter(({ cstat }) => !['101', '102'].includes(cstat))
			.map(nota => `Nota ${nota.nnf} / ${nota.serie}`)
			.join('<br>')
	}

	get itensFormatados() {
		return this.vendas.map(venda => ({
			...venda,
			displayNfSerie: this.displayNfSerie(venda),
			displayCliente: obterDisplayClienteDaVenda(venda),
			displayTotalDaVenda: this.displayTotalDaVenda(venda),
			displayStatusDaNota: this.displayStatusDaNota(venda),
			numeroDaNota: venda.notas[0] ? venda.notas[0].nnf : null,
			serieFiscal: venda.notas[0] ? venda.notas[0].serie : null,
		}))
	}

	podeCancelar(notas: NotaDaVenda[]) {
		return !notas.length || notas.some(({ cstat }) => cstat !== '101' && cstat !== '102')
	}


	podeCancelarPagamento(venda) {
		if(!venda.pontoDeVenda.loja.configuracaoDaLoja) return true 
		const limiteDeDias = venda.pontoDeVenda.loja.configuracaoDaLoja.limiteDeDiasParaCancelamentoAposEmissaoDaNota || 0
		
		const temNotasValidas = venda.notas.some(({ cstat }) => cstat !== '101' && cstat !== '102')

		if (temNotasValidas && limiteDeDias > 0) {
			const dhEmiMaisLimite = new Date(venda.notas[0].dhEmi)
			dhEmiMaisLimite.setDate(dhEmiMaisLimite.getDate() + limiteDeDias)

			if (limiteDeDias > 0 && new Date() <= dhEmiMaisLimite) {
				return true
			}
		} else if(venda.notas == 0) {
			return true
		}

		return false
	}

	async cancelarVenda(venda: ResumoDaVenda, motivoDoCancelamento?: string) {
		if (!venda) {
			AlertModule.setError('Venda a cancelar não encontrada')
			return
		}
		
		UserLoginStore.setCancelandoVenda(true)
		this.$forceUpdate
		try {
			if (this.cancelando.includes(venda.id))
				throw new Error('Venda já está em cancelamento')
			this.cancelando.push(venda.id)
			
			if(this.autenticacaoObrigatoriaParaVenda && venda.tipoDeTransacao === 'Venda') {

				this.permissaoConcedida = await VendaModule.autenticarAcao({ regra: 'pode-cancelar-venda', obrigatorioAutenticacao: true})
					
				if(this.permissaoConcedida) {
					if(!motivoDoCancelamento) return

					const usuarioAutenticado = localStorage.getItem('usuarioAutenticado')?.replace(/^"|"$/g, '')
						
					const vendaAtualizada = await this.cancelarVendaUseCase.cancelar(venda.id, usuarioAutenticado || null, motivoDoCancelamento)
					const vendaResumida = {
						...vendaAtualizada,
						total: obterTotalDaVenda(vendaAtualizada),
						vendaOrigem: undefined,
					} as ResumoDaVenda
					this.vendas = this.vendas.map(venda =>
						venda.id === vendaAtualizada.id ? vendaResumida : venda,
					)
					AlertModule.setSuccess(
						`Venda ${venda.identificador} cancelada com sucesso`,
					)
				}

			} else if (this.autenticacaoObrigatoriaParaDevolucao && venda.tipoDeTransacao === 'Devolução') {
					
				this.permissaoConcedida = await VendaModule.autenticarAcao({ regra: 'pode-cancelar-devolucoes', obrigatorioAutenticacao: true})

				if(this.permissaoConcedida) {
					if(!motivoDoCancelamento) return
					const usuarioAutenticado = localStorage.getItem('usuarioAutenticado')?.replace(/^"|"$/g, '')
					const vendaAtualizada = await this.cancelarVendaUseCase.cancelar(venda.id, usuarioAutenticado || null, motivoDoCancelamento)
					const vendaResumida = {
						...vendaAtualizada,
						total: obterTotalDaVenda(vendaAtualizada),
						vendaOrigem: undefined,
					} as ResumoDaVenda
					this.vendas = this.vendas.map(venda =>
						venda.id === vendaAtualizada.id ? vendaResumida : venda,
					)
					AlertModule.setSuccess(
						`Venda ${venda.identificador} cancelada com sucesso`,
					)
				}
			} else {
				if(venda.tipoDeTransacao === 'Venda') {
					if(!this.podeCancelarVenda) {
						this.permissaoConcedida = await VendaModule.autenticarAcao({ regra: 'pode-cancelar-venda'})

						if(this.permissaoConcedida) {
							if(!motivoDoCancelamento) return
							const usuarioAutenticado = localStorage.getItem('usuarioAutenticado')?.replace(/^"|"$/g, '')
							const vendaAtualizada = await this.cancelarVendaUseCase.cancelar(venda.id, usuarioAutenticado || null, motivoDoCancelamento)
							const vendaResumida = {
								...vendaAtualizada,
								total: obterTotalDaVenda(vendaAtualizada),
								vendaOrigem: undefined,
							} as ResumoDaVenda
							this.vendas = this.vendas.map(venda =>
								venda.id === vendaAtualizada.id ? vendaResumida : venda,
							)
							AlertModule.setSuccess(
								`Venda ${venda.identificador} cancelada com sucesso`,
							)
						}
					} else {
						if(!motivoDoCancelamento) return
						const usuarioAutenticado = localStorage.getItem('usuarioAutenticado')?.replace(/^"|"$/g, '')
						const vendaAtualizada = await this.cancelarVendaUseCase.cancelar(venda.id, usuarioAutenticado || null, motivoDoCancelamento)
						const vendaResumida = {
							...vendaAtualizada,
							total: obterTotalDaVenda(vendaAtualizada),
							vendaOrigem: undefined,
						} as ResumoDaVenda
						this.vendas = this.vendas.map(venda =>
							venda.id === vendaAtualizada.id ? vendaResumida : venda,
						)
						AlertModule.setSuccess(
							`Venda ${venda.identificador} cancelada com sucesso`,
						)
					}
				}

				if(venda.tipoDeTransacao === 'Devolução') {
					if(!this.podeCancelarDevolucao) {
						this.permissaoConcedida = await VendaModule.autenticarAcao({ regra: 'pode-cancelar-devolucoes'})

						if(this.permissaoConcedida) {
							if(!motivoDoCancelamento) return
							const usuarioAutenticado = localStorage.getItem('usuarioAutenticado')?.replace(/^"|"$/g, '')
							const vendaAtualizada = await this.cancelarVendaUseCase.cancelar(venda.id, usuarioAutenticado || null, motivoDoCancelamento)
							const vendaResumida = {
								...vendaAtualizada,
								total: obterTotalDaVenda(vendaAtualizada),
								vendaOrigem: undefined,
							} as ResumoDaVenda
							this.vendas = this.vendas.map(venda =>
								venda.id === vendaAtualizada.id ? vendaResumida : venda,
							)
							AlertModule.setSuccess(
								`Venda ${venda.identificador} cancelada com sucesso`,
							)
						}
					} else {
						if(!motivoDoCancelamento) return
						const usuarioAutenticado = localStorage.getItem('usuarioAutenticado')?.replace(/^"|"$/g, '')
						const vendaAtualizada = await this.cancelarVendaUseCase.cancelar(venda.id, usuarioAutenticado || null, motivoDoCancelamento)
						const vendaResumida = {
							...vendaAtualizada,
							total: obterTotalDaVenda(vendaAtualizada),
							vendaOrigem: undefined,
						} as ResumoDaVenda
						this.vendas = this.vendas.map(venda =>
							venda.id === vendaAtualizada.id ? vendaResumida : venda,
						)
						AlertModule.setSuccess(
							`Venda ${venda.identificador} cancelada com sucesso`,
						)
					}
				}
			}
		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.cancelando = this.cancelando.filter(id => venda.id !== id)
			UserLoginStore.setCancelandoVenda(false)
			this.$forceUpdate
		}
	}

	async cancelarNotasFiscais(venda: ResumoDaVenda) {
		if (!venda.notas.length) {
			AlertModule.setError('Venda não possui notas fiscais emitidas')
			return
		}

		this.cancelandoNotasFiscais.push(venda.id)

		try {
			const vendaAtualizada = await this.cancelarNotaFiscalUseCase.execute(
				venda.id,
			)

			const vendaResumida = {
				...vendaAtualizada,
				total: obterTotalDaVenda(vendaAtualizada),
				vendaOrigem: undefined,
			} as ResumoDaVenda
			this.vendas = this.vendas.map(venda =>
				venda.id === vendaAtualizada.id ? vendaResumida : venda,
			)
			const notasList = vendaAtualizada.notas
				.map(nota => `Nota ${nota.nnf} / ${nota.serie} cancelada com sucesso`)
				.join('<br>')
			AlertModule.setSuccess({
				text: notasList,
				timeout: -1,
			})
		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.cancelandoNotasFiscais = this.cancelandoNotasFiscais.filter(
				id => venda.id !== id,
			)
		}
	}

	gerarDataHora(
		data?: string | null,
		hora?: string | null,
	): string | undefined {
		return moment(`${data} ${hora}`, 'YYYY-MM-DD HH:mm').toISOString(true)
	}

	aplicarFiltros() {
		this.buscar()
	}

	created(){
		if(this.exibirSomenteVendasDoPdvAtivo === false) {
			this.filtro.datas = [null, null]
			this.filtro.horas = [null, null]
		}else{
			this.filtro.datas = this.dataAbertura
			this.filtro.horas = this.horaAbertura
		}
	}

	mounted() {
		UserLoginStore.setAutenticando(false)
		this.permissaoConcedida = false
	}

	get turnoDeVenda() {
		return VendaModule.turnoDeVenda
	}

	aplicarIds() {
		if(!this.turnoDeVenda?.pontoDeVenda.ativo) return
		if(!this.turnoDeVenda.pontoDeVenda.id) return
		this.filtro.lojaId = this.turnoDeVenda.pontoDeVenda.loja.id
		this.filtro.pdvId = this.turnoDeVenda.pontoDeVenda.id
	}

	async buscar() {
		await nextTick()
		try {

			if (this.filtro.datas[0] === null || this.filtro.datas[0] === '') {
				this.filtro.datas = [`${new Date().getFullYear()-1}-01-01`, this.filtro.datas[1] || null]
			}
			
			this.buscando = true
			const dataHoraInicial = this.gerarDataHora(
				this.filtro.datas[0],
				this.filtro.horas[0] || '00:00',
			)
			const dataHoraFinal = this.gerarDataHora(
				this.filtro.datas[1],
				this.filtro.horas[1] || '23:59',
			)
			const sorted = sortConverter(this.paginacao)

			if (this.exibirSomenteVendasDoPdvAtivo !== false) {
				this.aplicarIds()
				const page = await this.findUseCase.list({
					dataHoraInicial,
					dataHoraFinal,
					lojaId: this.filtro.lojaId || undefined,
					cliente: removerFormatacaoDeCnpjOuCpf((
						typeof this.filtro.cliente === 'string'
							? this.filtro.cliente
							: this.filtro.cliente?.cnpjOuCpf) || null,
					) || undefined,
					numeroNota: this.filtro.numeroDaNota || undefined,
					serie: this.filtro.serieFiscal || undefined,
					pdvId: this.filtro.pdvId || undefined,
					exibeVendasComErros: this.filtro.exibeVendasComErros,
					ambientes: this.filtro.ambientes.join(',') || undefined,
					identificador: this.filtro.identificador || undefined,
					vendasComOrcamento: this.filtro.vendasComOrcamento || undefined,
					vendasComPagamentoCancelado: this.filtro.vendasComPagamentoCancelado || undefined,
					page: this.paginacao.page,
					size: this.paginacao.itemsPerPage,
					sort: !sorted.length ? 'dataHora,desc' : sorted,
				})
				this.vendas = page.content
				this.totalRegistros = page.totalElements
				
			} else {
				
				const page = await this.findUseCase.list({
					dataHoraInicial,
					dataHoraFinal,
					lojaId: this.filtro.lojaId || undefined,
					cliente: removerFormatacaoDeCnpjOuCpf((
						typeof this.filtro.cliente === 'string'
							? this.filtro.cliente
							: this.filtro.cliente?.cnpjOuCpf) || null,
					) || undefined,
					numeroNota: this.filtro.numeroDaNota || undefined,
					serie: this.filtro.serieFiscal || undefined,
					pdvId: this.filtro.pdvId || undefined,
					exibeVendasComErros: this.filtro.exibeVendasComErros,
					ambientes: this.filtro.ambientes.join(',') || undefined,
					identificador: this.filtro.identificador || undefined,
					vendasComOrcamento: this.filtro.vendasComOrcamento || undefined,
					vendasComPagamentoCancelado: this.filtro.vendasComPagamentoCancelado || undefined,
					page: this.paginacao.page,
					size: this.paginacao.itemsPerPage,
					sort: !sorted.length ? 'dataHora,desc' : sorted,
				})
				this.vendas = page.content
				this.totalRegistros = page.totalElements
			}
		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.buscando = false
			this.dialogoDeFiltros.ocultar()
		}
	}

	async limparSelecaoDeFiltros() {
		try {
			this.buscando = true

			if (this.exibirSomenteVendasDoPdvAtivo !== false) {

				this.aplicarIds()
				const page = await this.findUseCase.list({
					lojaId: this.filtro.lojaId || undefined,
					pdvId: this.filtro.pdvId || undefined,
					page: this.paginacao.page,
					size: this.paginacao.itemsPerPage,
					sort:'dataHora,desc',
				})


				this.vendas = page.content
				this.totalRegistros = page.totalElements

			} else {
				const dataHoraInicial = this.gerarDataHora(
					this.filtro.datas[0],
					this.filtro.horas[0] || '00:00',
				)

				const page = await this.findUseCase.list({
					dataHoraInicial,
					page: this.paginacao.page -1,
					size: this.paginacao.itemsPerPage,
					sort: 'dataHora,desc',
				})

				this.vendas = page.content
				this.totalRegistros = page.totalElements

			}

		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.buscando = false
			this.dialogoDeFiltros.ocultar()
		}
	}

	abrirFiltros() {
		this.dialogoDeFiltros.mostrar()
	}

	@Watch('filtro', { deep: true })
	onChangeFiltro(newFiltro) {
		if (this.filtro.lojaId == null) {
			this.filtro.pdvId = ''
		}
		this.filtro.datas[0] =
			this.filtro.datas[0] !== null && this.filtro.datas[1] === null
				? null
				: this.filtro.datas[0]
		const stringified = JSON.stringify(newFiltro)
		localStorage.setItem(FILTRO_DE_VENDAS, stringified)
	}

	atualizarVenda(vendaAtualizada: ResumoDaVenda) {
		const indiceDaVenda = this.itensFormatados.findIndex(
			({ id }) => id === vendaAtualizada.id,
		)
		this.vendas.splice(indiceDaVenda, 1, vendaAtualizada)
	}

	navegar(page) {
		this.paginacao.page += page
		this.buscar()
	}

	async enviarPorEmail(venda: ResumoDaVenda) {
		try {
			if (this.enviandoEmail.includes(venda.id))
				throw new Error('Está venda já tem um processo de envio em andamento')

			if (venda.cliente) {
				if (venda.cliente.email) {
					this.enviandoEmail.push(venda.id)
					await this.editarUmaVendaUseCase.enviarEmail(
						venda.id,
						venda.cliente.email,
					)
				} else {
					this.dialogoDeInformarEmail.mostrar(venda)
				}
			} else {
				this.dialogoDeInformarEmail.mostrar(venda)
			}
		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.enviandoEmail = this.enviandoEmail.filter(id => venda.id !== id)
		}
	}

	temNotaParaEnviarEmail(venda: ResumoDaVenda) {
		return (
			venda.notas.filter((nota: NotaDaVenda) => nota.cstat === '100').length > 0
		)
	}

	get dataAbertura(): [] | [string | null, string | null] {
		if (!this.turnoDeVenda) return []; 
		const abertura = this.movimentacaoDeAbertura;
		if (!abertura) return [];

		const dataHora = new Date(abertura.dataHoraMovimentacao);
		const dataFormatada = `${dataHora.getFullYear()}-${adicionaZeroAEsquerda(dataHora.getMonth() + 1)}-${adicionaZeroAEsquerda(dataHora.getDate())}`;

		return [dataFormatada, ''];
	}

	get horaAbertura(): [string | null, string | null] {
		if (!this.turnoDeVenda || !this.movimentacaoDeAbertura) {
			return [null, null]; 
		}
		
		const dataHora = new Date(this.movimentacaoDeAbertura.dataHoraMovimentacao);
		const horaFormatada = `${adicionaZeroAEsquerda(dataHora.getHours())}:${adicionaZeroAEsquerda(dataHora.getMinutes())}`;

		return [horaFormatada, ''];
	}

	get movimentacaoDeAbertura() {
		if (!this.turnoDeVenda) return ''
		return this.turnoDeVenda.movimentacoes.find(
			({ tipoMovimentacao }) => tipoMovimentacao === 'Abertura',
		)
	}

	cancelarVendaComMotivo(motivoDoCancelamento: string, venda: ResumoDaVenda){
		if (!this.vendaSelecionada) return

		this.cancelarVenda(venda, motivoDoCancelamento)
		this.vendaSelecionada = null
	}

	abrirDialogoDeCancelamento(item) {
		this.vendaSelecionada = item

		this.$nextTick(() => {
			this.dialogoDeConfirmacaoDeCancelamentoDeVenda.abrirDialogo(item)
		})
	}
}

function adicionaZeroAEsquerda(num: number): string {
	return num < 10 ? `0${num}` : `${num}`;
}
